import type { FC } from 'react';
import { useCallback } from 'react';
import type { ActionProps } from '../../types';
import { observer } from 'mobx-react-lite';
import useRulePageMode from '../../hooks/useRulePageMode';
import useCurrentTasksFormStore from '../../hooks/useCurrentTasksFormStore';
import type { OptionValue } from '../../../../types/shared';
import { useConditionsConstants } from '../../api';
import { RuleEditAutoCompleteStyled } from '../RuleEditTasksFormComponents';

export const ActionMetrics: FC<ActionProps> = observer(({ indexAction, indexVariant, indexTask, field }) => {
  const { isRead } = useRulePageMode();
  const tasksFormStore = useCurrentTasksFormStore();
  const handleChangeMetric = useCallback(
    (value: OptionValue) => {
      tasksFormStore.setActionFieldValue({
        indexTask,
        indexAction,
        indexVariant,
        field,
        value: value as string,
      });
    },
    [tasksFormStore, indexTask, indexAction, indexVariant, field]
  );

  const { data: metrics } = useConditionsConstants({
    config: { select: (data) => data.map(({ name, id }) => ({ value: id, label: name })) },
  });

  const storedValue = tasksFormStore.getActionValues({ indexTask, indexAction, indexVariant })?.[field];
  return (
    <RuleEditAutoCompleteStyled
      allSelectable={false}
      value={storedValue as string}
      onChange={handleChangeMetric}
      id={`AutocompleteActionMetrics:${indexTask}.${indexAction}.${field}`}
      options={metrics ?? []}
      InputProps={{
        ...(tasksFormStore?.propsRestriction ?? null),
        disabled: isRead,
      }}
    />
  );
});

export default ActionMetrics;
